import React from "react";
import {CheckCircle2,Clock3,ShieldCheck} from "lucide-react";
import WebhookInfoCard from "./WebhookInfoCard";

function WebhookActivity({  webhook, formatDate}) {
  return (
    <section className="rounded-[18px] border border-[#d8e7ed] bg-[#f8fbfc] p-4 dark:border-dark-border dark:bg-dark-surface">
      {/* Header */}
      <div className="mb-3">
        <h3 className="text-[11px] font-bold text-[#344f61] dark:text-dark-text-primary">
          Delivery health
        </h3>
        <p className="mt-1 text-[9px] text-[#8194a0] dark:text-dark-text-muted">
          A compact history of verification and incoming events.
        </p>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-3">

        <WebhookInfoCard
          icon={ShieldCheck}
          label="Verified"
          value={formatDate(webhook.verified_at)}
          iconClass="bg-emerald-50 text-emerald-600"
        />

        <WebhookInfoCard
          icon={Clock3}
          label="Last Received"
          value={formatDate(webhook.last_received_at)}
          iconClass="bg-[#edf4f7] text-[#537788] dark:bg-[#20313a] dark:text-[#8fb2c1]"
        />

        <WebhookInfoCard
          icon={CheckCircle2}
          label="Created"
          value={formatDate(webhook.created_at)}
          iconClass="bg-[#f2efe8] text-[#8c774f] dark:bg-[#2c2920] dark:text-[#c2a878]"
        />

      </div>
    </section>
  );
}

export default WebhookActivity;
